import { ulid } from "ulid";
// Try to determine if the current page is a preview in the draft editor or a PageBuilder page
// being edited.
export function pageIsDraft() {
    try {
        const knownDraftCssClasses = ["drafts", "drafts-edit"];
        if (knownDraftCssClasses.find((c) => document.body.classList.contains(c))) {
            return true;
        }
        return (window.location.pathname.endsWith("/edit") || window.location.pathname.startsWith("/drafts/"));
    }
    catch {
        return false;
    }
}
// Guess if the user's device is a mobile or desktop.
// 1024x600 is probably the smallest screen size we consider a desktop (e.g. 10" netbooks)
// Mobile phones report virtual "CSS Pixels", so even retina screen iPhones will report relatively
// small screen sizes. For e.g. iphone 15 pro max is 430 × 932.
// When checking the size, remember that a phone might be in landscape mode, so check height and width.
export function deviceType() {
    try {
        if (window.screen.width >= 600 && window.screen.height >= 600)
            return "desktop";
        else
            return "mobile";
    }
    catch {
        return "unknown";
    }
}
export function findOrCreateDeviceId() {
    try {
        let deviceId = window.localStorage.getItem("tcDeviceId");
        if (deviceId == undefined || deviceId.length < 26) {
            deviceId = "v1:" + ulid();
            window.localStorage.setItem("tcDeviceId", deviceId);
        }
        return deviceId;
    }
    catch {
        // User's browser probably isn't allowing storage, which is unusual for a first-party domain.
        // Whatever, generate a temporary code for now. Note the different prefix.
        return "x1:" + ulid();
    }
}
